'use strict';

const { conditionIsGo, buildConditionItem, collectConditionFieldIds } = require('./conditionIsGo');

var simpleListValidateCtrl = [
    '$state', '$scope', '$uibModal', 'toast', 'Integration', "$sce",
    function ($state, $scope, $uibModal, toast, Integration, $sce) {
        var _this = this;
        this.model = this.model || [];
        this.hasIntegration = false;
        this.canFetchIntegration = false;
        this.loadingIntegration = false;
        this.preloadedOptions = []; // Para guardar las opciones iniciales

        if (_this.field.templateData.preloaded) {
            _this.preloadedOptions = JSON.parse(JSON.stringify(_this.field.templateData.options));
        }

        this.deleteRegister = function (index) {
            _this.model.splice(index, 1);
        }

        this.getTitle = function (record, divs) {
            if (!_this.field?.nodes || _this.field.nodes.length === 0) {
                return '';
            }

            // Todos los nodos dentro del simplelist y dentro de groups
            const getAllRelevantNodes = (nodes) => {
                let allNodes = [];
                nodes.forEach(node => {
                    if (node.type === 'group' && node.nodes && node.nodes.length > 0) {
                        allNodes = allNodes.concat(node.nodes);
                    } else {
                        allNodes.push(node);
                    }
                });
                return allNodes;
            };

            const allNodes = getAllRelevantNodes(_this.field.nodes);

            const titles = allNodes
                .filter(node => node.templateData?.useAsTitle)
                .map(node => maskValue(record[node.id]?.value || '', node));

            if (divs) {
                const width = titles.length > 0 ? (100 / titles.length) : 100;
                let recordValue = '';
                if (record && _this.field.nodes[0]) {
                    recordValue = record[_this.field.nodes[0].id]?.value;
                }
                return titles.length > 0 ?
                    $sce.trustAsHtml('<div style="padding-right: 5px;text-align:center;width:' + width + '%">'.concat(
                        titles.join('</div><div style="padding-right:5px;text-align:center;width:' + width + '%;">'),
                        "</div>"
                    )) : recordValue || '';
            }

            let recordValue = '';
            if (record && _this.field.nodes[0]) {
                recordValue = record[_this.field.nodes[0].id]?.value;
            }
            return titles.length > 0 ? titles.join(' ') : recordValue || '';
        };

        this.getHeaders = function () {
            if (!_this.field?.nodes || _this.field.nodes.length === 0) {
                return '';
            }

            // Todos los nodos dentro del simplelist y dentro de groups
            const getAllRelevantNodes = (nodes) => {
                let allNodes = [];
                nodes.forEach(node => {
                    if (node.type === 'group' && node.nodes && node.nodes.length > 0) {
                        allNodes = allNodes.concat(node.nodes);
                    } else {
                        allNodes.push(node);
                    }
                });
                return allNodes;
            };

            const allNodes = getAllRelevantNodes(_this.field.nodes);

            const titles = allNodes
                .filter(node => node.templateData?.useAsTitle)
                .map(node => node.name || '');

            const width = titles.length > 0 ? (100 / titles.length) : 100;

            return titles.length > 0 ?
                $sce.trustAsHtml('<div style="padding-right: 5px;text-align:center;width:' + width + '%">'.concat(
                    titles.join('</div><div style="padding-right:5px;text-align:center;width:' + width + '%;">'),
                    "</div>"
                )) : '';
        };

        this.openModal = function (index) {
            $uibModal.open({
                animation: true,
                templateUrl: 'directives/simpleListValidateDirectiveModal.html',
                controller: [
                    "$uibModalInstance",
                    "toast",
                    "field",
                    "item","completeModel","validatePayload",
                    "activeRecord",
                    "index",
                    function ($uibModalInstance, toast, field, item, completeModel,validatePayload, activeRecord, index) {
                        var _this = this;
                        this.item = item; 
                        this.completeModel = completeModel;
                        this.validatePayload = validatePayload;
                        this.field = field;
                        this.activeRecord = activeRecord;
                        field.nodes.forEach((field) => {
                            if (this.activeRecord[field.id] == undefined) {
                                this.activeRecord[field.id] = {
                                    type: field.type,
                                    id: field.id,
                                    value: undefined,
                                    
                                }
                            }
                        })

                        this.field = field;
                        this.isEdit = index > -1;
                        
                        this.validateFields = function() {
                            return _this.field.nodes.reduce((isValid,field) => {
                                if (isValid){
                                    if (field.nodes && field.nodes.length > 0 && field.inactiveGroup!=true)
                                        isValid = field.nodes.filter(n => n.validation?.required && _this.activeRecord[n.id] && (_this.activeRecord[n.id].value == undefined || _this.activeRecord[n.id].value == "")).length == 0;
                                    //field.nodes.filter(n => n.validation?.required && _this.activeRecord[n.id] && _this.activeRecord[n.id].value != undefined && _this.activeRecord[n.id].value != "").length == 0; 
                                    //field.nodes.filter(n => n.validation?.required).some(n => _this.activeRecord[n.id] && _this.activeRecord[n.id].value != undefined && _this.activeRecord[n.id].value != "")
                                    else if(field.validation?.required)
                                        isValid = _this.activeRecord[field.id].value != undefined && _this.activeRecord[field.id].value != "";
                                }

                                return isValid
                            },true);
                            
                        }

                        this.confirm = function () {
                            if(_this.validateFields())
                                $uibModalInstance.close({ record: this.activeRecord, index: index });
                        }
                        this.close = function () {
                            $uibModalInstance.dismiss();
                        };
                    },
                ],
                controllerAs: "ctrl",
                size: "lg",
                windowClass: "dialog",
                bindToController: true,
                resolve: {
                    field: () => _this.field,
                    item: () => _this.item,
                    completeModel: () => _this.completeModel,
                    activeRecord: () => index == -1 ? {} : JSON.parse(JSON.stringify(_this.model[index])),
                    index: () => index,
                    validatePayload: () => ({[_this.field.id]:{value:JSON.parse(JSON.stringify(_this.model))}}),
                }
            }).result.then((result) => {
                if (result.index > -1) {
                    _this.model[result.index] = result.record;

                } else {
                    _this.model.push(result.record);
                }
            }, function () { //dismiss
            });
        };

        // FOR INTEGRATIONS
        _this.paramsToRequest = {}; // Parametros para hacer el llamado al back
        _this.paramsIdToWatch = {}; // Id de los otros elementos que afectan al elemento actual y deben observarse.
        _this.populateValues = {};


        this.preloadValues = () => {
            const options = _this.preloadedOptions || [];
            const nodes = _this.field.nodes || [];

            _this.model = [];

            if (options.length > 0 && nodes.length > 0) {

                for (let i = 0; i < options.length; i++) {
                    let record = {};
                    record[nodes[0].id] = {
                        type: nodes[0].type,
                        id: nodes[0].id,
                        value: options[i]
                    };

                    for (let j = 1; j < nodes.length; j++) {
                        record[nodes[j].id] = {
                            type: nodes[j].type,
                            id: nodes[j].id,
                            value: ''
                        };
                    }
                    _this.model.push(record);
                }
            }
        }

        // Genera los registros (headers) a partir de opciones dinámicas calculadas con conditionIsGo, igual que en la app de carga.
        this.loadDynamicHeaders = () => {
            const item = buildConditionItem(_this.item && _this.item.payload, _this.completeModel);
            const options = conditionIsGo(_this.field.templateData.dynamicOptions, item) || [];
            const nodes = _this.field.nodes || [];

            if (!Array.isArray(options) || options.length === 0 || nodes.length === 0)
                return;

            _this.model = options.map((option) => {
                const record = {};
                record[nodes[0].id] = {
                    type: nodes[0].type,
                    id: nodes[0].id,
                    value: option
                };
                for (let j = 1; j < nodes.length; j++) {
                    record[nodes[j].id] = {
                        type: nodes[j].type,
                        id: nodes[j].id,
                        value: ''
                    };
                }
                return record;
            });
        }

        // SI NO TIENE INTEGRACIONES CHEQUEO SI TIENE DATA PRECARGADA/DINAMICA Y LA ASIGNO A MODEL
        // Chequear integration.id (no el objeto): puede venir { id: null, dynamicParams: null } y romper más abajo.
        if (!_this.field?.integration?.id) {

            if (_this.field.isDinamic && Array.isArray(_this.field.templateData.dynamicOptions)) {
                _this.loadDynamicHeaders();
                const idsToWatch = collectConditionFieldIds(_this.field.templateData.dynamicOptions, []);
                $scope.$watch("ctrl.completeModel", function (newValue, oldValue) {
                    if (newValue === oldValue)
                        return;
                    const changed = idsToWatch.some((id) => (newValue[id] && newValue[id].value) !== (oldValue[id] && oldValue[id].value));
                    if (changed)
                        _this.loadDynamicHeaders();
                }, true);
                return;
            }

            if (_this.field.templateData.preloaded) {
                _this.preloadValues();
            }
            return;
        } else {
            _this.hasIntegration = true;
        }

        Object.keys(_this.field?.integration?.defaultParams||{}).forEach(key => {
            _this.paramsToRequest[key] = _this.field?.integration?.defaultParams[key] ?? "";
        })

        Object.keys(_this.field?.integration?.dynamicParams).forEach(key => {
            _this.paramsToRequest[key] = _this.field?.integration?.defaultParams[key] ?? "";

            const value = _this.field?.integration?.dynamicParams[key];
            _this.paramsIdToWatch[value] = _this.field?.integration?.defaultParams ?? ""; // This params are used to filter fetch data.
        });

        // Populate Params
        Object.keys(_this.field?.integration?.populateValues).forEach(key => {
            _this.populateValues[key] = _this.field?.integration?.populateValues[key];
        });
        
        this.reloadParams = function () {
            Object.keys(_this.paramsToRequest).forEach(key => {
                const fieldId = _this.field?.integration?.dynamicParams[key];
                _this.paramsToRequest[key] = _this.completeModel[fieldId]?.value ?? (_this.item.payload[fieldId]?.value ?? _this.paramsToRequest[key]);
                if(_this.paramsToRequest[key]=="{item.validate}"){
                    _this.paramsToRequest[key] = _this.item.validate || [];
                }
            })
            this.getRequest(_this.paramsToRequest)
        }

        this.getRequest = (paramsRef) => {
            // Filtramos paramsRef para eliminar keys con valores vacíos
            const filteredParams = Object.keys(paramsRef).reduce((acc, key) => {
                if (paramsRef[key] !== '') {
                    acc[key] = paramsRef[key];
                }
                return acc;
            }, {});

            // Si no quedan parámetros después del filtro, no hacemos el llamado
            if (Object.keys(filteredParams).length === 0) {
                console.log('Llamado no realizado porque paramsRef está vacío o tiene valores inválidos');
                _this.canFetchIntegration = false;
                return;
            }

            // console.log('paramsRef2', paramsRef)
            _this.canFetchIntegration = true;
            _this.loadingIntegration = true;

            Integration.request(
                { integrationId: _this.field.integration.id },
                {
                    onlyWS: false,
                    params: paramsRef
                }
            ).$promise
            .then((json) => {
                // console.log('JSON INTEGRATION SIMPLE LIST', json)
                if (Array.isArray(json.response)) {
                    // Procesar la respuesta de Integration
                    _this.model = json.response.map((responseItem) => {
                        const record = {};

                        // Mapear valores usando _this.populateValues
                        Object.keys(_this.populateValues).forEach((key) => {
                            const fieldId = _this.populateValues[key]; // ID del nodo en field.nodes
                            const field = _this.field.nodes.reduce((selected, node) => {
                                if (node.id === fieldId)
                                    selected = node.id;
                                else if (selected == undefined && node.nodes) {
                                    selected = node.nodes.find((subnode) => subnode.id === fieldId);
                                }
                                return selected;
                            }, undefined); // _this.field.nodes.find((node) => node.id === fieldId);

                            if (field) {
                                if (field.type == 'number') {
                                    record[fieldId] = {
                                        type: field.type,
                                        id: field.id,
                                        value: typeof responseItem[key] !== 'number' ? 
                                            parseFloat(responseItem[key]) : 
                                            responseItem[key],
    
                                    };
                                } else {
                                    record[fieldId] = {
                                        type: field.type,
                                        id: field.id,
                                        value: responseItem[key], // Tomar el valor del backend
                                    };
                                }
                            }
                        });

                        return record;
                    });
                    _this.loadingIntegration = false;
                } else if (_this.field.templateData.preloaded) {
                    // Asignar datos precargados, si es necesario
                    _this.preloadValues();
                    _this.loadingIntegration = false;
                } else {
                    _this.loadingIntegration = false;
                }
            })
            .catch((e) => {
                console.log(e);
                _this.loadingIntegration = false;
            })
        }

        $scope.$watch("ctrl.completeModel", function (newValue, oldValue) {
            if (newValue === oldValue)
                return;

            let hasChanges = false;
            Object.keys(newValue).forEach((key) => {
                if (_this.paramsIdToWatch.hasOwnProperty(key)) {
                    const newVal = newValue[key]?.value;
                    const oldVal = oldValue[key]?.value;

                    if (newVal != oldVal) {
                        hasChanges = true;
                    }
                }
            });

            if (hasChanges) {
                if (_this.completeModel[_this.field.id] && _this.completeModel[_this.field.id].value !== undefined) {
                    // ASIGNAR VALORES DE LA INTEGRACION
                } else {
                    console.log('La clave o el valor no existen');
                }
                _this.field.templateData.options = []
                _this.reloadParams();
            }
        }, true);

        this.reloadIntegrationData = () => {
            console.log('reloadIntegrationData');
        }

        _this.reloadParams(); // Cuando carga la primera vez el elemento field
    }];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            item: '=',
            model: '=',
            completeModel: "=",
        },
        controller: simpleListValidateCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/simpleListValidateDirective.html'
    };
};
